import { render, staticRenderFns } from "./sso-oauth2.vue?vue&type=template&id=6f20b7f4&"
import script from "./sso-oauth2.ts?vue&type=script&lang=ts&"
export * from "./sso-oauth2.ts?vue&type=script&lang=ts&"
import style0 from "./sso-oauth2.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports